import { withStyles } from '@material-ui/core';
import styles from './ProfilePics.style';
import ProfilePics from './ProfilePics';

export default withStyles(styles)(ProfilePics);
